var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.isVisible,"color":_vm.color},on:{"input":_vm.close},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"icon":""},on:{"click":_vm.close}},'v-btn',attrs,false),[_c('v-icon',[_vm._v("fa-times")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }